import { object, string } from 'yup';

const schema = object().shape({
  // firstName: string().required("Required"),
  // lastName: string().required("Required"),
  // email: string().email().required("Required"),
  // profilePicUrl: string().url().required("Required"),
  // icsUrl: string().url().required("Required"),
  // mobile: string()
});

export default schema;
